import { Dispatch } from 'redux';
import { MessageTypes } from '.';

export const setMessage = (value?: string) => (dispatch: Dispatch) => {
	dispatch({ type: MessageTypes.SetMessage, payload: { message: value } });
};

export const setError = (value?: string) => (dispatch: Dispatch) => {
	dispatch({ type: MessageTypes.SetError, payload: { error: value } });
};
